



















import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import {
  GroupedBotProperty,
  PropertyFieldType
} from '../../../../../../../../../../../BotProperties/components/Properties/types'
import { getPropertiesByType, prepareForFormulaInput, setPlaceholderPath } from '../../../../../../../../../../../BotProperties/utils'
import ConfigField from '../../../../../../../../../../../ConfigField/ConfigField.vue'
import { SelectOptionData } from '../../../../../../../../../../../Pi/types'
import FormulaInput from '../../../../../../../../../../../f/FormulaInput.vue'
import { PropValueCalculate } from '../../../../../logic/Actions/PropertyAction/PropertyActionValue'

@Component({
  components: {
    FormulaInput,
    ConfigField,
  }
})
export default class PropertyValueCalculate extends Vue {
  @Prop() value!: PropValueCalculate

  @Prop() getProperties!: () => Array<GroupedBotProperty>

  get formula(): string {
    return this.value.value
  }

  set formula(val: string) {
    this.setConstValue(val)
  }

  get propertiesNames(): Array<SelectOptionData> {
    const placeholdersWithPath = setPlaceholderPath(this.getProperties())
    const numProperties = getPropertiesByType(placeholdersWithPath, [ PropertyFieldType.Double, PropertyFieldType.Number ])

    return prepareForFormulaInput(this.$i18n, numProperties)
  }

  @Emit()
  setConstValue(formula: string): string {
    return formula
  }
}
